import { Group, Pagination, Select, Text } from '@mantine/core';

const LIST_PAGE_SIZES = ['10', '25', '50', '100'];

interface ListPagerProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageSizes?: string[];
}

/** Same footer on Patients, Tasks, and Schedule: count on the left, pages and page size on the right. */
export function ListPager({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  pageSizes = LIST_PAGE_SIZES
}: ListPagerProps) {
  if (total <= 0 || pageSize <= 0) return null;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const from = (safePage - 1) * pageSize + 1;
  const to = Math.min(safePage * pageSize, total);

  return (
    <Group justify="space-between" align="center" mt="sm" wrap="nowrap">
      <Text size="sm" c="dimmed">
        Showing {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}
      </Text>
      <Group gap="md" align="center" wrap="nowrap">
        <Pagination
          size="sm"
          radius="md"
          color="plum.9"
          value={safePage}
          total={totalPages}
          onChange={onPageChange}
          withControls
        />
        <Group gap={6} align="center" wrap="nowrap">
          <Text size="sm" c="dimmed" style={{ whiteSpace: 'nowrap' }}>
            Rows per page
          </Text>
          <Select
            size="xs"
            w={76}
            value={String(pageSize)}
            onChange={(value) => {
              const next = Number(value);
              if (Number.isFinite(next) && next > 0) onPageSizeChange(next);
            }}
            data={pageSizes}
            allowDeselect={false}
            comboboxProps={{ withinPortal: true }}
          />
        </Group>
      </Group>
    </Group>
  );
}
